import { MessageCircle, Globe } from 'lucide-react';
import '../css/OpenInBrowserIllustration.css';

/**
 * The picture at the top of the "Open in Your Browser" popup: an app window
 * on the left, an arrow, and a browser window on the right — "move from the
 * app to your browser" at a glance.
 *
 * Decorative only (aria-hidden): the popup's title and message carry the
 * meaning. The app window deliberately uses a generic chat glyph rather than
 * any company's logo. The browser window takes the club's accent colour
 * (Config -> Theme -> Active Button Color) so it matches the button below.
 *
 * @returns {JSX.Element}
 */
function OpenInBrowserIllustration() {
  return (
    <div className="oib-illustration" aria-hidden="true">
      <div className="oib-window oib-window-app">
        <div className="oib-window-bar">
          <span /><span /><span />
        </div>
        <div className="oib-window-body">
          <span className="oib-badge oib-badge-app">
            <MessageCircle size={22} strokeWidth={2.4} />
          </span>
        </div>
      </div>

      <svg className="oib-arrow" viewBox="0 0 64 40" fill="none">
        <path d="M6 8c4 18 22 26 44 24" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" />
        <path d="M44 24l8 8-9 6" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>

      <div className="oib-window oib-window-browser">
        <div className="oib-window-bar">
          <span /><span /><span />
        </div>
        <div className="oib-window-body">
          <span className="oib-badge oib-badge-browser">
            <Globe size={24} strokeWidth={2.2} />
          </span>
        </div>
        <span className="oib-spark oib-spark-1" />
        <span className="oib-spark oib-spark-2" />
        <span className="oib-spark oib-spark-3" />
      </div>
    </div>
  );
}

export default OpenInBrowserIllustration;
